export default __webpack_public_path__ + "static/media/coments.c92ad1c6.svg";